/**
 * Stable CSS class names for E2E — Create return / Active step 3.
 */
export const CRAS3 = {
    root: 'create-return-step3',
    loadingSection: 'create-return-step3__loading-section',

    addDrawerPaper: 'create-return-step3__add-bank-drawer-paper',
    addDrawerHeaderRoot: 'create-return-step3__add-bank-drawer-header',
    addDrawerHeaderTitle: 'create-return-step3__add-bank-drawer-header-title',
    addDrawerHeaderCloseIcon: 'create-return-step3__add-bank-drawer-header-close-icon',
    addDrawerContent: 'create-return-step3__add-bank-drawer-content',

    editDrawerPaper: 'create-return-step3__edit-bank-drawer-paper',
    editDrawerContent: 'create-return-step3__edit-bank-drawer-content',

    sectionTitle: 'create-return-step3__section-title',
    refundAmountText: 'create-return-step3__refund-amount-text',
    productCountText: 'create-return-step3__product-count-text',

    approveButton: 'create-return-step3-input--button-approve-return',

    cmiYRow: 'create-return-step3__cmiy-row',
    cmiYControl: 'create-return-step3-input--cmiy-control',
    cmiYCheckbox: 'create-return-step3-input--cmiy-checkbox',

    planInfoHeader: 'create-return-step3__plan-info-header',
    planTableWrap: 'create-return-step3__plan-table-wrap',
    planTable: 'create-return-step3__plan-table',
    planRow: 'create-return-step3__plan-row',
    planCellMethod: 'create-return-step3__plan-cell-method',
    planCellAmount: 'create-return-step3__plan-cell-amount',
    planCellStatus: 'create-return-step3__plan-cell-status',

    selectMethodHeader: 'create-return-step3__select-method-header',
    methodCardCash: 'create-return-step3-input--card-method-cash',
    methodCardLcwMoney: 'create-return-step3-input--card-method-lcw-money',
    methodCardBank: 'create-return-step3-input--card-method-bank-transfer',

    savedBankInfoTitle: 'create-return-step3__saved-bank-info-title',
    addNewBankInfoLink: 'create-return-step3-input--link-add-new-bank-info',

    bankAccountCard: 'create-return-step3__bank-account-card',
    bankAccountCardTitle: 'create-return-step3__bank-account-card-title',
    bankAccountEditLink: 'create-return-step3-input--link-bank-account-edit',
    bankAccountDeleteLink: 'create-return-step3-input--link-bank-account-delete',

    storeEmployeeWarningCard: 'create-return-step3__store-employee-warning-card',
    goToReturnDetailButton: 'create-return-step3-input--button-go-to-return-detail',

    returnAddressCard: 'create-return-step3__return-address-card',
} as const;

export const cras3Cls = (...parts: Array<string | undefined | false>) => parts.filter(Boolean).join(' ');

